<h1 i18n>Profile Settings</h1>
<app-basic-settings></app-basic-settings>
